import React from 'react';
import './Exhibitorcard.css';

const ExhibitorCard = (props) => {
    return (
        <div className='exhibitor-card'>
            <div className='exhibitor-card__img-wrap'>
                <img src={props.imgSrc} alt={`${props.title} showcase`} className='exhibitor-card__img' />
                <span className='exhibitor-card__img-label'>{props.imgLabel}</span>
            </div>
            <div className='exhibitor-card__body'>
                <h2 className='exhibitor-card__title'>{props.title}</h2>
                <p className='exhibitor-card__subtitle'>{props.subtitle}</p>
                <p className='exhibitor-card__text'>{props.text}</p>
            </div>
        </div>
    );
};

export default ExhibitorCard;